import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import AppContext from '../../../state/AppContext';
import APIInvoke from '../../../utils/APIInvoke';
import { Paper } from '@mui/material';

const Metrics = ( props) => {

    const [metrics, setMetrics] = useState(undefined)
    const { appContext } = useContext(AppContext)
    const project = appContext.project
    const [counter, setCounter] = useState(0);
    const [isRunning, setIsRunning] = useState(true);


    useEffect(() => {
        fetchData()
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            setCounter(prev => prev + 1);
        }, 3000);

        // Limpieza del intervalo cuando el componente se desmonte
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!isRunning) return;
        fetchData();
    }, [counter]);

    const fetchData = async () => {
        try {
            const response = await (await APIInvoke.invokeGET(`/projects/${project}/dashboard/metrics`)).json()
            setMetrics(response.body)
        } catch (error) {
            console.error("Error fetching metrics", error)
        } 
    }


    const formatMemory = (value) => {
        if (value >= 1099511627776) {
            return (value / 1000000).toFixed(2) + ' TB';
        } else if (value >= 1000) {
            return (value / 1000).toFixed(2) + ' GB';
        } else {
            return value.toFixed(1) + ' MB';
        }
    }


    const getGaugeOption = (value, max, title) => ({
        series: [{
            type: 'gauge',
            max: max,
            min: 0,
            center: ['50%', '60%'],
            startAngle: 210,
            endAngle: -30,
            splitNumber: 5,
            progress: {
                show: true,
                roundCap: true,
                width: 18
            },
            itemStyle: {
                color: '#58D9F9',
                shadowColor: 'rgba(0,138,255,0.45)',
                shadowBlur: 10,
                shadowOffsetX: 2,
                shadowOffsetY: 2
            },
            radius: '100%',
            pointer: {
                show: false
            },
            axisLine: {
                roundCap: true,
                lineStyle: {
                    width: 18
                }
            },
            axisTick: {
                splitNumber: 2,
                lineStyle: {
                    width: 2,
                    color: '#999'
                }
            },
            splitLine: {
                length: 12,
                lineStyle: {
                    width: 3,
                    color: '#999'
                }
            },
            axisLabel: {
                distance: 30,
                color: '#999',
                fontSize: 14,
                formatter: function (value) {
                    return Math.round(value);
                }
            },
            title: {
                show: false,
            },
            detail: {
                fontSize: 20,
                offsetCenter: [0, '20%'],
                valueAnimation: true,
                color: '#333',
                formatter: function (value) {
                    return value
                },
            },
            data: [{
                value: value,
                name: title
            }]
        }]
    });

    if (!metrics) return <div>Cargando...</div>;

    const cpuUsage = parseFloat(metrics.cpu.systemCpuLoad);
    const availableProcessors = metrics.cpu.availableProcessors;

    const memoryUsed = metrics.memory.usedPhysicalMemory;
    const memoryMax = metrics.memory.totalPhysicalMemory;

    const activeThreads = metrics.asyncExecutor.activeThreads;
    const maxThreads = metrics.asyncExecutor.poolSize;

    return (
        <div className="grid grid-cols-3 gap-4">
            <div >
                <Paper className="">
                    <ReactECharts option={getGaugeOption(cpuUsage, availableProcessors)} />
                    <p className="text-xl text-center font-bold bg-gray-100 p-2 border-t border-gray-300">CPU</p>
                </Paper>
            </div>
            <div >
                <Paper className="">
                    <ReactECharts option={{
                        ...getGaugeOption(memoryUsed, memoryMax),
                        series: [{
                            ...getGaugeOption(memoryUsed, memoryMax).series[0],
                            axisLabel: {
                                distance: 30,
                                color: '#999',
                                fontSize: 8,
                                formatter: formatMemory
                            },
                            detail: {
                                fontSize: 20,
                                offsetCenter: [0, '20%'],
                                valueAnimation: true,
                                color: '#333',
                                formatter: formatMemory
                            },
                        }]
                    }} />
                    <p className="text-xl text-center font-bold bg-gray-100 p-2 border-t border-gray-300">Memory</p>
                </Paper>
            </div>
            <div >
                <Paper className="">
                    <ReactECharts option={getGaugeOption(activeThreads, maxThreads)} className="h-full" />
                    <p className="text-xl text-center font-bold bg-gray-100 p-2 border-t border-gray-300">Threads</p>
                </Paper>
            </div>
        </div>
    );
};

export default Metrics;
